import React, { useEffect } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from "@mui/material";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnCancel, BtnConfirm, BtnSend } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertTitleTh, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { onCheckDataResponPIS } from './CpnFunction';


const ModalRejectPart = (props) => {

    const {
        form,
        nStatusID,
        IsRoleDM,
        IsOpen,
        setIsOpen,
        sVOCFormID,
        setIsOpenSnackbar,
        setsSeveritySnackbar,
        setsMessageSnackbar,
        sMaxWidth = "md",
        nJobTypeID
    } = props;

    
    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const navigate = useNavigate();

    const schema = yup.object().shape({
        sReason: yupFormSchemas.string("เหตุผล", { required: true }),
    });
    const formPR = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    useEffect(() => {
        if (IsOpen == true) {
            formPR.setValue("sReason", null)
            formPR.clearErrors();
        }
    }, [IsOpen])

    const onSubmitRejectPart = () => {

        let param = {
            "sVOCFormID": sVOCFormID,
            "sMode": "PR",
            "sRemark": formPR.getValues("sReason") ?? null,
        }
        SwAlert.Confirm(AlertTitleTh.Confirm, nJobTypeID == 1 ? "คุณต้องการที่จะไม่ยอมรับข้อร้องเรียนใช่หรือไม่ ?" : "คุณต้องการที่จะไม่ยอมรับข้อร้องขอใช่หรือไม่ ?", () => {
            setIsOpen(false)
            BlockUI();

            AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate("/Backend/HomeBackEnd")
                        }, 2000)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();

                    }
                })
            }, null, null)
        })
    }

    return (
        <Dialog
            open={IsOpen}
            onClose={() => { setIsOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={sMaxWidth}
        >
            <DialogTitle>กรุณาระบุเหตุผล</DialogTitle>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogContent>
                <FormProvider {...formPR}>
                    <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center">
                        <Grid item xs={12}>
                            <InputCustomLabel
                                id="sReason"
                                name="sReason"
                                label="เหตุผล"
                                required={true}
                                multiline={true}
                                rows={4}
                                fullWidth
                                maxLength={1000}
                            />
                        </Grid>
                    </Grid>
                </FormProvider>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center" >
                    <Grid item>
                        <BtnConfirm txt='ยืนยัน' onClick={formPR.handleSubmit(() => { onSubmitRejectPart() })} />
                    </Grid>
                    <Grid item>
                        <BtnCancel txt={"ยกเลิก"} onClick={() => { setIsOpen(false) }} />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ModalRejectPart